import { useQuery } from 'react-query';
import { useLocation } from 'react-router';
import { useEnvironment } from '../contexts/EnvironmentContext';
import { SharepointApiParams } from '..';

export const useSharepointQuery = <T>(
  entity: string,
  fetchData: (params: SharepointApiParams) => Promise<T> | T,
  cacheKey?: string,
  withFilters = true
) => {
  const env = useEnvironment();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const optionalParams = Object.fromEntries(queryParams.entries());
  const environment = env.settings.environment;
  //deconstruct filters from location.search and construct back into a string
  const selectedFilters = readFilterTagsFromQuery(location.search);
  const defaultCacheKey =
    entity + '|' + constructSearchQueryFromFilters(selectedFilters);
  return useQuery<T>(cacheKey ?? defaultCacheKey, () =>
    fetchData(
      withFilters
        ? {
            ...optionalParams,
            apiKey: env.settings.ocpApimKey,
            baseUrl: env.settings.apiBaseURL,
            entity,
            module: env.moduleName,
            environment,
          }
        : {
            apiKey: env.settings.ocpApimKey,
            baseUrl: env.settings.apiBaseURL,
            entity,
            module: env.moduleName,
            environment,
          }
    )
  );
};

const staticFilters = ['client', 'region', 'country'];

const readFilterTagsFromQuery = (search: string) => {
  const query = new URLSearchParams(search);
  const filterTags: string[] = [];

  staticFilters.forEach((filter, i) => {
    const filterValue = query.get(filter);
    if (filterValue) {
      filterTags[i] = filterValue;
    }
  });
  return filterTags;
};

const constructSearchQueryFromFilters = (filters: string[]): string => {
  const searchParams = new URLSearchParams();

  filters.forEach((x, i) => {
    if (i < staticFilters.length && x !== '') {
      searchParams.append(staticFilters[i], x);
    }
  });

  return searchParams.toString();
};
